import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Card,
  CardTitle,
  Col,
  Input,
  FormGroup,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import CustomTableHeader from "../../common/CustomTableHeader";
import CustomUserAvatar from "../../common/CustomUserAvatar";
import CustomViewButton from "../../common/CustomViewButton";
import CustomEditButton from "../../common/CustomEditButton";
import CustomDeleteButton from "../../common/CustomDeleteButton";
import {
  ADMIN_USERS_URL,
  USER_DETAILS_URL,
  USER_DELETE_URL,
} from "../../../utils/APIEndpoints";
import {
  authHeader,
  loggedUserDetails,
} from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  SingleStringFirstLetterCaps,
  getAlertToast,
  getConfirm,
  getCountryCode,
} from "../../../utils/functions/CustomFunctions";
import CustomTableLoader from "../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SET_ADMIN_FORM_PROFILE_PICTURE } from "../../../redux/actions/ActionTypes";
import AdminCRUDDialog from "./AdminCRUDDialog";
import Swal from "sweetalert2";
import View from "./view";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";

//Table Columns
const tableColumns = [
  { title: "Profile" },
  { title: "First Name" },
  { title: "Last Name" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Actions" },
];

function Admins(props) {
  const { dispatch } = props;
  const { userId = "" } = loggedUserDetails();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    count: 10,
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [isAdd, setIsAdd] = useState(true);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: "",
  });
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
    });
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          offset: currentPage,
        }),
      500
    )
  ).current;

  const viewToggle = () => setViewModal(!viewModal);
  const createToggle = () => setCreateModal(!createModal);

  const viewRecord = async (userId, e) => {
    setCurrentUserId(userId);
    setViewModal(true);
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    // return;
    queryParams = {
      ...queryParams,
      role: "Paygov Admin",
    };
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: ADMIN_USERS_URL,
        headers: authHeader(),
        params: queryParams,
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        let dataToDis = initialResponse.map((record) => {
          let { firstName, lastName } = record;
          let formattedData = {
            firstName: SingleStringFirstLetterCaps(firstName),
            lastName: SingleStringFirstLetterCaps(lastName),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
        setTotalRecords(dataToDis.length);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRowPerPage = ({ target: { value, name } }) => {
    setCurrentPage(0);
    setFilter((va) => ({ ...va, [name]: value || undefined }));
  };

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    }));
  };

  //Add New Admin
  const AddNewAdmin = () => {
    setUserData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      address: "",
    });
    setIsAdd(true);
    setCreateModal(true);
    dispatch({
      type: SET_ADMIN_FORM_PROFILE_PICTURE,
      payload: "",
    });
  };

  //Callback
  const submitCallback = () => {
    setCreateModal(false);
    getGridData({
      ...filter,
      offset: currentPage,
    });
  };

  //Edit Record
  const editRecord = async (userId, event) => {
    setLoading(true);
    const options = {
      method: "GET",
      url: USER_DETAILS_URL,
      headers: authHeader(),
      params: { userId },
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        setIsAdd(false);
        setUserData(response.data);
        setCreateModal(true);
        dispatch({
          type: SET_ADMIN_FORM_PROFILE_PICTURE,
          payload: response.data.profileImage,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Delete Record
  const deleteRecord = async (userId, e) => {
    Swal.fire(
      getConfirm("warning", "Are you sure do you want to delete?")
    ).then((result) => {
      if (result.value) {
        deleteAdmin(userId);
      }
    });
  };

  const deleteAdmin = async (userId) => {
    try {
      setLoading(true);
      const options = {
        method: "DELETE",
        url: USER_DELETE_URL,
        headers: authHeader(),
        params: { userId },
      };
      const response = await API(options);
      const { status } = response.data;
      if (status === "Success") {
        getGridData({
          ...filter,
          offset: currentPage,
        });
        Swal.fire(getAlertToast("success", "Record removed successfully"));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const { firstName, lastName, email, phoneNumber } = filter;

  return (
    <div>
      <Card body className="mt-5">
        <div className="tableTitleBg mb-4">
          <CardTitle className=" " style={{ margin: "0" }}>
            Admins
          </CardTitle>
          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "0px 7px 3px 16px",
              fontSize: "19px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
          <Button className="f-r" color="primary" onClick={AddNewAdmin}>
            <i className="fas fa-user-plus" /> New Admin
          </Button>
        </div>
        {isFilterOpen && (
          <Row form className="mb-4">
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={changeFilterField}
                  value={firstName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={changeFilterField}
                  value={lastName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={changeFilterField}
                  value={email}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>+1</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    onChange={changeFilterField}
                    value={phoneNumber}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          {/* Table Header */}
          <CustomTableHeader tableColumns={tableColumns} />
          {/* Table Header */}

          {/* Table Body */}
          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => (
                      <tr key={`record_key_${key}`}>
                        <td>
                          {/* Custom Avatar */}
                          <CustomUserAvatar srcPath={record.profileImage} />
                          {/* Custom Avcatar */}
                        </td>
                        <td>{record.firstName}</td>
                        <td>{record.lastName}</td>
                        <td>{record.email}</td>
                        <td>
                          {getCountryCode()}
                          {record.phoneNumber}
                        </td>
                        <td>
                          {/* Custom View Button  */}
                          <CustomViewButton
                            keyvalue={key}
                            data-user_id={record.userId}
                            onClick={(e) => viewRecord(record.userId, e)}
                          />
                          {/* Custom View Button  */}

                          {/* Custom Edit Button  */}
                          <CustomEditButton
                            keyvalue={key}
                            data-user_id={record.userId}
                            onClick={(e) => editRecord(record.userId, e)}
                          />
                          {/* Custom Edit Button  */}

                          {/* Custom Remove Button  */}
                          {parseInt(userId) !== parseInt(record.userId) && (
                            <CustomDeleteButton
                              keyvalue={key}
                              data-user_id={record.userId}
                              onClick={(e) => deleteRecord(record.userId, e)}
                            />
                          )}
                          {/* Custom Remove Button  */}
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
          {/* Table Body */}
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={handleRowPerPage}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>

      {/* CRUD Dialog */}
      <AdminCRUDDialog
        submitCallback={submitCallback}
        modal={createModal}
        toggle={createToggle}
        userData={userData}
        isAdd={isAdd}
      />
      {/* CRUD Dialog */}

      {/* View Dialog */}
      {viewModal && (
        <View
          userId={currentUserId}
          viewToggle={viewToggle}
          viewModal={viewModal}
        />
      )}
      {/* View Dialog */}
    </div>
  );
}
const getState = () => {
  return {};
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({}, dispatch),
  dispatch,
});
export default connect(getState, mapDispatchToProps)(Admins);
